export const MainContent: React.FC = ({
    children
}) => {
    return (
        <main className="relative md:pl-24 pt-20 bg-gray-100 bg-opacity-80 min-h-screen">
                {children}
        </main>
    );
};